export const isLocalApp = (): boolean => location.hostname === 'localhost';
